import React from 'react';
import { X } from 'lucide-react';

const CourseModal = ({ 
  setActiveModal, 
  courseData, 
  setCourseData,
  onAddLogEntry,
  activeVoyage
}) => (
  <div className="p-6">
    <div className="flex justify-between items-center mb-4">
      <h3 className="text-lg font-semibold">Log Course Change</h3>
      <button onClick={() => setActiveModal(null)} className="text-gray-400 hover:text-gray-600">
        <X className="h-5 w-5" />
      </button>
    </div>
    
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">New Course (degrees) *</label>
        <input
          type="text"
          value={courseData.course}
          onChange={(e) => setCourseData({...courseData, course: e.target.value})}
          placeholder="e.g., 270"
          className="w-full px-3 py-2 border border-gray-300 rounded-md"
        />
      </div>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Speed (knots)</label>
        <input
          type="text"
          value={courseData.speed}
          onChange={(e) => setCourseData({...courseData, speed: e.target.value})}
          placeholder="e.g., 12"
          className="w-full px-3 py-2 border border-gray-300 rounded-md"
        />
      </div>
      
      <div className="flex gap-2 pt-4">
        <button
          onClick={() => setActiveModal(null)}
          className="flex-1 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50"
        >
          Cancel
        </button>
        <button
          onClick={() => {
            if (courseData.course) {
              onAddLogEntry({
                type: 'COURSE_CHANGE',
                category: 'navigation',
                summary: `Altered course to ${courseData.course}°`,
                description: courseData.speed ? `Speed: ${courseData.speed} knots` : '',
                timestamp: new Date().toISOString(),
                voyageId: activeVoyage?.id,
                data: courseData
              });
              setCourseData({ course: '', speed: '' });
              setActiveModal(null);
            }
          }}
          disabled={!courseData.course}
          className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400"
        >
          Log Course Change
        </button>
      </div>
    </div>
  </div>
);

export default CourseModal;